<template>
    <div class="container-fluid">
        <div class="card card-primary card-outline" id="newworkflow">
            <div class="card-body">
                <div class="bootbox-body">
                    <form class="change-password-form">
                        <div class="">
                            <div class="row form-group">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <span class="text-danger" id="error_msg"></span>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label>Title:<span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" rows="3" @change="remove_error('title')" :class="{ 'is-invalid': form.errors.has('title') }" id="title" v-model="form.title" placeholder="Working address"/>
                                    <has-error :form="form" field="title"></has-error>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <label>Description:<span class="text-danger">*</span></label>
                                    <textarea class="form-control" v-model="form.description" :class="{ 'is-invalid': form.errors.has('description')}" id="description"  @change="remove_error('description')"></textarea>
                                    <has-error :form="form" field="description"></has-error>
                                </div>
                            </div>
                            <div class="row form-group">
                                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <label class="mb-0.5">Status:</label>
                                    <label><input  type="radio" v-model="form.status" value="1" tabindex="" checked /> Active</label>
                                    <label><input  type="radio" v-model="form.status" value="0" tabindex=""/> Inactive</label>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="card-footer">
                <div class="row form-group fa-pull-right">
                    <div class="col-md-12">
                        <button type="button" class="btn btn-flat btn-primary" @click="SaveDetails()"> <i class="fa fa-edit"></i> Create</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return  {
            form: new form({
                id:'',
                title:'',
                description:'',
                action :'edit',
                status:''
            })
        }
    },
    methods:{
        SaveDetails(){
            this.form.post('create_annocement')
            .then(() => {
                    Toast.fire({
                        icon: 'success',
                        title: 'Details Updated Successfully'
                    })
                    this.$router.push('/list_annocement');
            })
            .catch((err) => {
                console.log("Error:"+err)
            });
        },
        removeerror(fieldid,errid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
                $('#'+errid).html('');
            }
        },
    },
    created(){
        this.form.status=this.$route.params.data.status;
        this.form.id=this.$route.params.data.id;
        this.form.title=this.$route.params.data.title;
        this.form.description=this.$route.params.data.description;
    },
}
</script>
